import { initializeBrowserTelemetry } from "./telemetry";
import { readBrowserTelemetryConfig } from "./read-browser-telemetry-config";

try {
  initializeBrowserTelemetry(readBrowserTelemetryConfig() ?? undefined);
} catch (error) {
  console.warn(
    "[tinkertoy-shell:telemetry] Browser telemetry bootstrap failed",
    error,
  );
}
